import Vue from "vue";
import formTestDriveCompleted from "./components/form-test-drive-completed.vue";
import store from "./store.js";
import "./assets/main.scss";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuelidate);

if (window.modalManager) {
    window.modalManager.registerFormType('test-drive-completed', {
        Vue: Vue,
        formComponent: formTestDriveCompleted,
        store: store
    });
}

window.createApp_test_drive_completed = function(selector, props = {}) {
    if (!window.modalManager) {
        console.error('ModalManager not available for createApp_test_drive_completed');
        return;
    }

    if (!window.modalManager.isFormTypeRegistered('test-drive-completed')) {
        window.modalManager.registerFormType('test-drive-completed', {
            Vue: Vue,
            formComponent: formTestDriveCompleted,
            store: store
        });
    }

    return window.modalManager.createFormApp('test-drive-completed', selector, props);
};
window.createApp_testDriveCompleted = window.createApp_test_drive_completed;

let renderTestDriveCompletedForms = function() {
    const forms = document.querySelectorAll('.form-test-drive-completed');
    if (forms.length === 0) {
        return false;
    }

    if (!window.modalManager) {
        console.error('ModalManager not available for renderTestDriveCompletedForms');
        return false;
    }

    if (!window.modalManager.isFormTypeRegistered || !window.modalManager.isFormTypeRegistered('test-drive-completed')) {
        window.modalManager.registerFormType('test-drive-completed', {
            Vue: Vue,
            formComponent: formTestDriveCompleted,
            store: store
        });
    }

    forms.forEach((form, index) => {
        try {
            const parentBlock = form.closest('.nitea-form-selector');

            if (parentBlock) {
                return;
            }

            if (!form.id) {
                form.id = `form-test-drive-completed-footer-${Date.now()}-${index}`;
            }

            window.modalManager.createFormApp('test-drive-completed', `#${form.id}`, {
                displayMode: 'modal'
            });
        } catch (error) {
            console.error(`Failed to initialize test-drive-completed form ${index}:`, error);
        }
    });

    return true;
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderTestDriveCompletedForms);
} else {
    renderTestDriveCompletedForms();
}

window.renderTestDriveCompletedForms = renderTestDriveCompletedForms;
